const capitalizeFirstWord = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return str?.replace(/\b\w/g, (char) => char?.toUpperCase());
};

export default capitalizeFirstWord;
